import { render, staticRenderFns } from "./WizardCard.vue?vue&type=template&id=17dd547e&scoped=true&"
import script from "./WizardCard.vue?vue&type=script&lang=js&"
export * from "./WizardCard.vue?vue&type=script&lang=js&"
import style0 from "./WizardCard.vue?vue&type=style&index=0&id=17dd547e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd547e",
  null
  
)

export default component.exports